import { makeStyles } from '@mui/styles';
import { ApplicationMuiTheme } from '@tassat/payments-themes/dist/types/theme';

import { SimpleTableProps } from './types';

export const muiStyles = makeStyles((theme: ApplicationMuiTheme) => ({
    root: {
        // height: '100%',
        borderRadius: '4px 4px 0 0',
        '& .ag-theme-material': { fontSize: '12px' },
        '& .ag-layout-normal > .ag-body-viewport.ag-layout-normal': { overflowY: 'inherit' as const },
        '& .ag-theme-material .ag-header': { border: 'none' as const },
        '& .ag-theme-material .ag-header-cell': {
            color: theme?.app?.applicationColors.fontColor || '#202020',
            fontWeight: 'bold' as const
        },
        '& .ag-theme-material .ag-row': { border: 'none' as const },
        '& .ag-theme-material .ag-cell': { lineHeight: (props: SimpleTableProps) => props.rowHeight || '26px' },
        '& .ag-theme-material .ag-status-bar': { border: 'none' as const }
    },
    titleContainer: {
        minHeight: '25px',
        backgroundColor: theme?.app?.clientTheme.colors.primaryColor || '#3C4F70',
        borderRadius: '4px 4px 0 0',
        padding: '4px 8px'
    },
    title: {
        fontWeight: 'bold' as const,
        fontSize: '14px',
        lineHeight: '17px',
        textTransform: 'uppercase' as const,
        color: theme?.app?.applicationColors.enumColors.white || '#FFFFFF'
    },
    gridContainer: {
        minHeight: (props: SimpleTableProps) => (props.minHeight ?
            `${props.minHeight}px`
            : '240px'),
        width: '100%'
    }
}));